import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Section } from '../components/ui/Section';
import { Container } from '../components/ui/Container';
import { Shield, Lock, Globe, AlertTriangle } from 'lucide-react';
export function About() {
  return <Layout data-id="element-665">
      <Section spacing="lg" data-id="element-666">
        <Container size="md" data-id="element-667">
          <div className="text-center mb-16" data-id="element-668">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-6" data-id="element-669">
              About CyberSecurityProtocol 101
            </h1>
            <p className="text-xl text-slate-400" data-id="element-670">
              Global standards-based cybersecurity guidance and real-world
              operational practices.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-671">
            <Card className="p-8 border-t-4 border-t-cyan-500" data-id="element-672">
              <Shield className="h-8 w-8 text-cyan-500 mb-4" data-id="element-673" />
              <h2 className="text-2xl font-bold text-slate-100 mb-4" data-id="element-674">
                Our Mission
              </h2>
              <p className="text-slate-400" data-id="element-675">
                To democratize professional-grade cybersecurity protocols. We
                believe that effective security shouldn't be a secret or a
                luxury. It should be a standard operating procedure accessible
                to everyone.
              </p>
            </Card>

            <Card className="p-8 border-t-4 border-t-cyan-500" data-id="element-676">
              <Globe className="h-8 w-8 text-cyan-500 mb-4" data-id="element-677" />
              <h2 className="text-2xl font-bold text-slate-100 mb-4" data-id="element-678">
                Standards Alignment
              </h2>
              <p className="text-slate-400 mb-4" data-id="element-679">
                Our protocols are not invented from scratch. They are rigorous
                adaptations of global standards:
              </p>
              <ul className="list-disc list-inside text-slate-400 space-y-2" data-id="element-680">
                <li data-id="element-681">NIST Cybersecurity Framework 2.0</li>
                <li data-id="element-682">ISO/IEC 27001:2022</li>
                <li data-id="element-683">CIS Controls v8</li>
              </ul>
            </Card>
          </div>

          <section className="mb-16" data-id="element-684">
            <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-685">
              <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-686" />
              Ethical Positioning
            </h2>
            <div className="bg-slate-900/50 p-6 rounded-lg border border-slate-800" data-id="element-687">
              <ul className="space-y-4 text-slate-300" data-id="element-688">
                <li className="flex items-start" data-id="element-689">
                  <span className="text-green-500 mr-2" data-id="element-690">✓</span>
                  We focus exclusively on <strong data-id="element-691">
                    defensive security
                  </strong>{' '}
                  (Blue Team).
                </li>
                <li className="flex items-start" data-id="element-692">
                  <span className="text-green-500 mr-2" data-id="element-693">✓</span>
                  We do not host leaked data, exploits, or malware.
                </li>
                <li className="flex items-start" data-id="element-694">
                  <span className="text-green-500 mr-2" data-id="element-695">✓</span>
                  We align with national laws (UU PDP) and international
                  regulations (GDPR).
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-696">
            <div className="bg-yellow-500/10 border border-yellow-500/20 p-6 rounded-lg flex items-start" data-id="element-697">
              <AlertTriangle className="h-6 w-6 text-yellow-500 mr-4 flex-shrink-0" data-id="element-698" />
              <div data-id="element-699">
                <h3 className="font-bold text-yellow-500 mb-2" data-id="element-700">Disclaimer</h3>
                <p className="text-sm text-yellow-200/80" data-id="element-701">
                  CyberSecurityProtocol 101 provides guidance based on best
                  practices. Cybersecurity is contextual; no system is 100%
                  immune. This guide does not encourage illegal access,
                  exploitation, or the use of leaked data. Always consult with
                  qualified professionals for your specific situation.
                </p>
              </div>
            </div>
          </section>
        </Container>
      </Section>
    </Layout>;
}